
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexPfvuuNHdBIhtKil0loauVta72zdVk5pCv7Gso6ncl00Meta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/index.vue?macro=true";
import { default as reportsphn83bEgR8EqEpdz7d14Y_45dMavOTsoCPbJ5drHN_45KM4Meta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/reports.vue?macro=true";
import { default as simcards9rxSQM57kDHKOfBiw7TuQ51h3cNItqjKq_45_45OyxMkusYMeta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/simcards.vue?macro=true";
import { default as loginzx5zOyPUDSjayp8YRQ_zmvEHiJFHr1SWg0UsGGyUZfkMeta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/auth/login.vue?macro=true";
import { default as index7BJ0X9c_45y_45IZ75SyAHG8O0M4w0FxP1FvAhUXPXJ_45QwsMeta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/import/index.vue?macro=true";
import { default as callback5U9t7caGGSBK5t8YV35aLiDql87LrffkNXn3hqQPdp4Meta } from "/builds/application/sim-portal/monorepo/apps/frontend/pages/auth/callback.vue?macro=true";
export default [
  {
    name: "index___de",
    path: "/",
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/index.vue")
  },
  {
    name: "reports___de",
    path: "/reports",
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/reports.vue")
  },
  {
    name: "simcards___de",
    path: "/simcards",
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/simcards.vue")
  },
  {
    name: "auth-login___de",
    path: "/auth/login",
    meta: loginzx5zOyPUDSjayp8YRQ_zmvEHiJFHr1SWg0UsGGyUZfkMeta || {},
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/auth/login.vue")
  },
  {
    name: "import___de",
    path: "/import",
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/import/index.vue")
  },
  {
    name: "auth-callback___de",
    path: "/auth/callback",
    meta: callback5U9t7caGGSBK5t8YV35aLiDql87LrffkNXn3hqQPdp4Meta || {},
    component: () => import("/builds/application/sim-portal/monorepo/apps/frontend/pages/auth/callback.vue")
  }
]